import quit from '../../assets/img/quit.png';
import loginBg from '../../assets/loginBg.jpg';
// import logo from '../../assets/logo.png';
import refresh from '../../assets/img/refresh.png';
import avatar from '../../assets/img/avatar.png';
import details from '../../assets/img/details.png';
import index1 from '../../assets/img/index/index01.png';
import index2 from '../../assets/img/index/index02.png';
import index3 from '../../assets/img/index/index03.png';
import index4 from '../../assets/img/index/index04.png';
import index5 from '../../assets/img/index/index05.png';

export default{
	quit,
	loginBg,
	// logo,
	refresh,
	avatar,
	details,
	index:{
		index1,
		index2,
		index3,
		index4,
		index5,
	}
}